import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/cross.png'
import _imports_1 from '../assets/images/tick-shadow.png'


const _hoisted_1 = { class: "payment-failed" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "tick"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "shadow"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_retry_button = _resolveComponent("retry-button")!
  const _component_powered_by_footer = _resolveComponent("powered-by-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("h2", null, _toDisplayString(_ctx.error.title?_ctx.error.title:'Payment failed'), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.error.message?_ctx.error.message: 'An unexpected error occurred'), 1)
    ]),
    _createVNode(_component_powered_by_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_retry_button, {
          buttonText: 'Try Again',
          color: 'orange',
          onClick: _ctx.retry
        }, null, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}